import Action from "../../classes/Action";
import { StepUIData } from "../../interfaces/UITemplateData";
import store, { StoreActions } from '../../state/store';

export default class DiscardTemplateChanges extends Action
{
	constructor(slideId: string, backup: StepUIData | null)
	{
		const newSlide = backup;
		const oldSlide: StepUIData = { ...store.getState().uiModule.slideMaster[slideId] };

		super(
			[slideId, newSlide],
			[slideId, oldSlide],
			`Discard Template Changes`,
			[newSlide, oldSlide]
		);
	}

	do(slideId: string, newSlide: StepUIData)
	{
		const newSlideJson = JSON.stringify(newSlide);
		const slideTemplate = JSON.parse(newSlideJson);

		slideTemplate.name = newSlide.name;
		slideTemplate.type = 'slide';

		store.dispatch(StoreActions.ui.setSlideFromCopy({ slide: slideId, content: { ...slideTemplate } }));
	}

	undo(slideId: string, oldSlide: StepUIData)
	{
		store.dispatch(StoreActions.ui.setSlideFromCopy({ slide: slideId, content: { ...oldSlide } }));
	}

	verify(newSlide: StepUIData, oldSlide: StepUIData)
	{
		if (!newSlide) return false;
		if (!oldSlide) return false;
		return true;
	}
}
